import { render } from "./Unit.vue?vue&type=template&id=560e0fc0&scoped=true"
import script from "./Unit.vue?vue&type=script&lang=js"
export * from "./Unit.vue?vue&type=script&lang=js"

import "./Unit.vue?vue&type=style&index=0&id=560e0fc0&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560e0fc0"]])

export default __exports__